import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { GlobalService } from '../../shared/services/global/global.service';
import { ModalsService } from '../../shared/services/modals/modals.service';
import { RECORD_STATUS_VALUES, TABLE_OPTION_VALUES, TRAVEL_SERVICES } from '../../shared/constants/api-constants';
import { LeadsService } from 'src/app/business-service/leads/leads.service';
import { ComponentReloadService } from '../../shared/services/reload/component-reload.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DmcQuotesService } from 'src/app/business-service/dmc-quotes/dmc-quotes.service';
import { InvoiceService } from 'src/app/business-service/invoice/invoice.service';
import { PdfService } from '../../shared/services/pdf.service';
import { ResponseNotificationService } from '../../shared/services/response-notification/response-notification.service';
import { LovDataService } from '../../shared/services/lov-data/lov-data.service';
import { FirebaseDatabaseService } from '../../shared/services/firebase-database/firebase-database.service';
import { TasksService } from 'src/app/business-service/tasks/tasks.service';
import { CallsService } from 'src/app/business-service/calls/calls.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-dmc-lead-details',
  templateUrl: './dmc-lead-details.component.html',
  styleUrls: ['./dmc-lead-details.component.scss'],
})
export class DmcLeadDetailsComponent implements OnInit {

  leadDetails: any;
  @Input() leadIdUrl: any;

  @ViewChild('newLeadNote') newLeadNote!: ElementRef;

  quoteDetails: any;

  showInvoice: any = false;
  showCreateQuoteButton: boolean = true;
  showEditButton: any;

  allLeadItinerarys: any = {
    data: [],
    pageNumber: 1,
    pageSize: 10
  };
  allLeadItineraryColumns: any = [
    { key: "itineraryId", colName: "Quote ID", showColumn: true },
    { key: "leadId", colName: "Lead ID", showColumn: false },
    { key: "leadName", colName: "Lead Name", showColumn: false },
    { key: "destination", colName: "Destination", showColumn: true },
    { key: "totalDays", colName: "Nights", showColumn: true },
    { key: "travelDate", colName: "Travel Date", showColumn: true },
    { key: "totalAdults", colName: "Travelers", showColumn: true },
    { key: "tourPackageAmount", colName: "Amount", showColumn: true },
    { key: "status", colName: "Status", showColumn: true },
    { key: "createdBy", colName: "Created By", showColumn: true },
    { key: "createDate", colName: "Created Date", showColumn: true }
  ]

  allLeadTasks: any = {
    data: [],
    pageNumber: 1,
    pageSize: 10
  };

  showInvoiceSection: any;
  hideTaskView: any;
  hideCreateTask: any;

  clientInvoice: any = {
    data: [],
    pageNumber: 1,
    pageSize: 10
  };
  clinentInvoiceColumsn: any = [
    { key: "invoiceId", colName: "ID", showColumn: true, routePath: '/invoice/details/' },
    { key: "invoiceDate", colName: "Invoice Date", showColumn: true, formatter: "date" },
    { key: "dueDate", colName: "Due Date", showColumn: true, formatter: "date" },
    { key: "totalAmount", colName: "Amount", showColumn: true, formatter: "currency: INR" },
    { key: "balanceAmount", colName: "Balance", showColumn: true, formatter: "currency: INR" },
    { key: "status", colName: "Status", showColumn: true }
  ]

  invoiceOptionsValues: any =
    {
      idKey: 'invoiceId',
      options: [
        { value: "View", path: "details" },
        { value: "Edit", path: "edit" },
        { value: "Add Payment", path: "addPayment" },
        { value: "Delete", path: "delete" }
      ]
    }

  leadGuestColumns: any = [
    { key: "contactId", colName: "ID", showColumn: true },
    { key: "firstName", colName: "Name", showColumn: true },
    { key: "phoneNumber", colName: "Phone Number", showColumn: true },
    { key: "age", colName: "Age", showColumn: true },
    { key: "gender", colName: "gender", showColumn: true },
    { key: "documents", colName: "Documents", showColumn: true },
  ]

  guestsOptionsValues: any =
    {
      idKey: 'guestId',
      options: [
        { value: "View", path: "details" },
        { value: "Edit", path: "edit" },
        { value: "Delete", path: "delete" }
      ]
    }

  leadTaskColumns: any = [
    { key: "taskId", colName: "ID", showColumn: true, routePath: '/tasks/details/' },
    { key: "dueDate", colName: "Due Date", showColumn: true, formatter: 'date' },
    { key: "ownershipName", colName: "Assigned To", showColumn: true },
    { key: "subject", colName: "Subject", showColumn: true },
    { key: "priority", colName: "Priority", showColumn: true },
  ]

  tasksOptionsValues: any =
    {
      idKey: 'taskId',
      options: [
        { value: "View", path: "details" },
        { value: "Edit", path: "edit" },
        { value: "Delete", path: "delete" }
      ]
    }

  taskStatusLov: any;

  // lead of client
  allLeadsOfClient: any = {
    data: [],
    pageNumber: 1,
    pageSize: 10
  };

  allDmcVendorsEmails: any = {
    data: [],
    pageNumber: 1,
    pageSize: 10
  };


  leadsOfClientColumns: any = [
    { key: "leadId", colName: "Lead ID", showColumn: true, routePath: "/clients/lead/" },
    { key: "itineraryId", colName: "Quote ID", showColumn: true, emitRowOnClick: true },
    { key: "createDate", colName: "Created Date", showColumn: true, formatter: "date" },
    { key: "ownershipName", colName: "Assigned To", showColumn: true },
    { key: "travelServices", colName: "Service Type", showColumn: true },
    { key: "destinations", colName: "Destinations", showColumn: true },
    { key: "source", colName: "Source", showColumn: true },
    { key: "status", colName: "Status", showColumn: true }
  ]


  VendorDmcColumns: any = [
    { key: "organizationName", colName: "DMC / Vendor Name", showColumn: true },
    { key: "destination", colName: "Destination", showColumn: true },
    { key: "fromEmail", colName: "Send By", showColumn: true },
    { key: "status", colName: "Status", showColumn: true, emitRowOnClick: true },
    { key: "createDate", colName: "Date", showColumn: true, formatter: "date" },
  ]

  // calls of lead
  allCallsOfLead: any = {
    data: [],
    pageNumber: 1,
    pageSize: 10
  };
  callsOfLeadsColumns: any = [
    { key: "contact", colName: "Contact Name", showColumn: true },
    { key: "number", colName: "Number", showColumn: true },
    { key: "type", colName: "Type", showColumn: true, },
    { key: "date", colName: "Date", showColumn: true, formatter: "date: MMM d, yyyy - h:mm a" },
    { key: "duration", colName: "Duration", showColumn: true, formatter: "secondsToTime" },
    { key: "createdBy", colName: "Created By", showColumn: true, cssClass: "" }
  ]

  role: any;
  showQuoteButton: any;
  hideCompleteOptions: any;
  allcontactsdata: any;
  originalmailsdata: any;

  private subscribeToCallsEvent: Subscription | undefined;

  constructor(
    private _globalService: GlobalService,
    private _modalPopupService: ModalsService,
    private _leadService: LeadsService,
    private _reloadService: ComponentReloadService,
    private _activatedRoute: ActivatedRoute,
    private _dmcQuoteService: DmcQuotesService,
    private _invoiceService: InvoiceService,
    private _router: Router,
    private _pdfServie: PdfService,
    private _responseNotificationService: ResponseNotificationService,
    private _lovDataService: LovDataService,
    private _firebaseDbService: FirebaseDatabaseService,
    private _tasksService: TasksService,
    private _callsService: CallsService
  ) { }

  async ngOnInit() {
    await this.loadLovData();
    this.role = localStorage.getItem("Role");

    this._globalService.roles$.subscribe((roles) => {
      const leadModule = roles?.modules.find((module: any) => module.name === "Leads");
      this.showQuoteButton = leadModule?.permissions?.createQuote;
      this.showEditButton = leadModule?.permissions?.editLead;

      if (this.role === "ClientAccountant") {
        this.hideCompleteOptions = true;
      }
      else {
        this.hideCompleteOptions = false;
      }
      const invoiceModule = roles?.modules.find((module: any) => module.name === "Invoice & Receipts");
      if (!invoiceModule || !invoiceModule.permissions) {
        this.showInvoiceSection = false;
      } else {
        if (!invoiceModule?.permissions?.createInvoice &&
          !invoiceModule?.permissions?.viewInvoice &&
          !invoiceModule?.permissions?.editInvoice &&
          !invoiceModule?.permissions?.deleteInvoice) {
          this.showInvoiceSection = false;
        }
        else {
          this.showInvoiceSection = true;
        }
      }
      const taskModule = roles?.modules.find((module: any) => module.name === "Tasks");
      if (!taskModule || !taskModule.permissions) {
        this.hideTaskView = true;
      } else {
        this.hideTaskView = taskModule.permissions.viewTask;
        this.hideCreateTask = taskModule.permissions.createTask;

        this.tasksOptionsValues = {
          idKey: 'taskId',
          options: []
        };

        if (taskModule.permissions.viewTask) {
          this.tasksOptionsValues.options.push({ value: "View", path: "details" });
        }
        if (taskModule.permissions.editTask) {
          this.tasksOptionsValues.options.push({ value: "Edit", path: "edit" });
        }
        if (taskModule.permissions.deleteTask) {
          this.tasksOptionsValues.options.push({ value: "Delete", path: "delete" });
        }

      }
    })

    if (!this.leadIdUrl) {
      this.leadIdUrl = this._activatedRoute.snapshot.paramMap.get("leadId");
    }

    this.getLeadDetails();

    this._reloadService.reloadLeads$.subscribe(() => {
      this.getLeadDetails();
    });

    this.getDefaultLeadQuotes();
    this.getDefaultTasks();
    this.getCallsOfLead();

    this._reloadService.reloadQuotes$.subscribe(() => {
      this.getDefaultLeadQuotes();
    })
    this._reloadService.reloadTasks$.subscribe(() => {
      this.getDefaultTasks()
    })
    this._reloadService.reloadInvoices$.subscribe(() => {
      this.getDefaultInvoicesForLead()
    })
    this._reloadService.reloadTravelPref$.subscribe(() => {
      this.getLeadDetails();
    })
    
    this.subscribeFirebaseDatabaseService();
  }

  subscribeFirebaseDatabaseService() {
    this.subscribeToCallsEvent = this._firebaseDbService.subscribeToCallsEvent().subscribe((data: any) => {
      this.getCallsOfLead();
    }, error => {
      console.error('Error fetching data:', error);
    });
  }

  // General method
  scrollTo(section: string) {
    document.getElementById(section)?.scrollIntoView({ behavior: 'smooth' });
  }
  navigatePrev() {
    this._globalService.navigatePrev();
  }

  createTaskForLead() {
    this._modalPopupService.openTasksForm(null, this.leadIdUrl, (goNew) => {
      if (goNew) {
        this.createTaskForLead(); // Open a new form
        // this.getDefaultTasks();
      } else {
        // this.getDefaultTasks();
      }
    });
  }

  createQuote() {
    this._modalPopupService.openDmcQuoteForm(this.leadDetails.leadId, null)
  }

  openLeadEdit() {
    this._modalPopupService.openDmcLeadForm(this.leadIdUrl);
  }

  async loadLovData() {
    this._lovDataService.getLovData('TaskStatus').subscribe((data) => {
      this.taskStatusLov = data;
    })
  }

  getLeadDetails() {
    this._leadService.getLead(this.leadIdUrl).subscribe((data) => {
      this.leadDetails = data;

      if (this.leadDetails.itineraryId) {
        this.getQuoteDetails(this.leadDetails.itineraryId);
      }
      if (this.leadDetails.status === RECORD_STATUS_VALUES.QUOTE_CREATED || this.leadDetails.status === RECORD_STATUS_VALUES.CONVERTED || this.leadDetails.status === RECORD_STATUS_VALUES.TRIP_COMPLETED) {
        this.showInvoice = true;
      }

      if (this.showInvoice) {
        this.getDefaultInvoicesForLead();
      }

      if (this.leadDetails.clientId) {
        this.getDefaultLeadsOfClinet(this.leadDetails.clientId, null);
      }
    })
  }

  getQuoteDetails(quoteId: any) {
    this._dmcQuoteService.getQuoteData(quoteId).subscribe((data) => {
      this.quoteDetails = data.itineraryDetails;
    })
  }

  // Get defalut invoices for lead
  getDefaultInvoicesForLead() {
    this._invoiceService.getAllInvoiceForLead(this.leadIdUrl, null, null, null).subscribe((data) => {
      this.clientInvoice = data;
    })
  }

  // leads of clients function
  getDefaultLeadsOfClinet(clientId: any, paginationSettings: any) {
    this._leadService.getLeadsOfClient(clientId, paginationSettings?.pageNumber, paginationSettings?.pageSize, null).subscribe((data) => {
      this.allLeadsOfClient = data;
      this.allLeadsOfClient.data = data.data.map((lead: any) => ({
        ...lead,
        fullName: `${lead.firstName} ${lead.lastName}`,
        fullPhoneNumber: lead.phoneNumber
          ? `${lead.phoneNumber.countryCode || ''} ${lead.phoneNumber.phone || ''}`
          : '',
        destinations: lead.destination ? lead.destination.map((d: any) => this._globalService.getFirstItemOfString(d.location)) : [],
        travelServices: lead.travelServices.includes(TRAVEL_SERVICES.TOUR_PACKAGE) ? TRAVEL_SERVICES.TOUR_PACKAGE : lead.travelServices

      }));
    })
  }

  // Get default quote
  getDefaultLeadQuotes() {
    this._dmcQuoteService.getAllItinerarysForLead(this.leadIdUrl, null, null, null).subscribe((data) => {
      this.allLeadItinerarys = data;

      if (Object.keys(this.allLeadItinerarys.data).length > 0) {
        this.showCreateQuoteButton = false;
      } else {
        this.showCreateQuoteButton = true;
      }
    })
  }

  // get all qutoes of lead
  getAllQuotesForLead(paginationSettings: any) {
    this._dmcQuoteService.getAllItinerarysForLead(this.leadIdUrl, paginationSettings.pageNumber, paginationSettings.pageSize, null).subscribe((data) => {
      this.allLeadItinerarys = data;
    })
  }

  // get default tasks
  getDefaultTasks() {
    this._tasksService.getAllTasksOfLead(this.leadIdUrl, null, null, null).subscribe((data) => {
      this.allLeadTasks = data;
      this.allLeadTasks.data = this.allLeadTasks.data.map((task: any) => ({
        ...task,
        statusLov: this.taskStatusLov
      }))
    })
  }

  // Calls of lead functions
  getCallsOfLead(paginationSettings: any = null) {
    this._callsService.getCallsOfLeads(this.leadIdUrl, paginationSettings?.pageNumber, paginationSettings?.pageSize).subscribe((allLeads) => {
      this.allCallsOfLead = allLeads;
    })
  }



  // Quote Grid funtions

  onOptionSelected(event: any) {
    let path = event.path;
    let row = event.row;

    switch (path) {
      case TABLE_OPTION_VALUES.DELETE: {
        this.deleteQuote(row.itineraryId)
        break;
      }
      case TABLE_OPTION_VALUES.EDIT: {
        this.editQuote(row.itineraryId, row.leadId, row.clientId)
        break;
      }
      case TABLE_OPTION_VALUES.FINALIZE: {
        this.finalizeQuote(row.itineraryId, row.leadId, row.clientId)
        break;
      }
      case TABLE_OPTION_VALUES.FINALIZE_AND_CONVERT: {
        this.finalizeAndConvertQuote(row.itineraryId, row.leadId, row.clientId)
        break;
      }
      case TABLE_OPTION_VALUES.CONVERT: {
        this.convertQuote(row.itineraryId, row.leadId)
        break;
      }
      case TABLE_OPTION_VALUES.DOWNLOAD: {
        this.downloadQuoteAsPdf(row.itineraryId);
        break;
      }
      // TODO: add login to clone quote
    }
  }

  onTableCellClicked(event: any) {
    let row = event.row;
    let column = event.column;

    switch (column) {
      case "itineraryId": {
        this.viewQuote(row.itineraryId, row.leadId, row.clientId, row.status);
        break;
      }
      case "leadId": {
        this._router.navigate(['/leads/details', row.leadId]);
        break;
      }
    }

  }

  editQuote(quoteId: any, leadId: any, clientId: any) {
    this._modalPopupService.openDmcQuoteForm(leadId, quoteId)
  }

  async deleteQuote(quoteId: any) {
    if (await this._globalService.confirmActionPopup(`Are you sure to delete ${quoteId}`, "Confirm Delete", "Yes")) {
      this._dmcQuoteService.deleteQuote(quoteId).subscribe((data) => {
        this._responseNotificationService.showMessage("Quote Deleted Successfully!")
        this._reloadService.triggerQuotesReload();
      })
    }
  }

  finalizeQuote(quoteId: any, leadId: any, clientId: any) {
    this.checkAndFinalizeQuote(quoteId, leadId, clientId)
  }

  convertQuote(quoteId: any, leadId: any) {
    // TODO: write login to convert quote only change status
  }

  finalizeAndConvertQuote(quoteId: any, leadId: any, clientId: any) {
    this._modalPopupService.openReviewDmcQuoteView(quoteId, leadId, clientId);
  }

  viewQuote(itineraryId: any, leadId: any, clientId: any, status: any) {
    if (status === RECORD_STATUS_VALUES.DRAFT) {
      this._modalPopupService.openDmcQuoteForm(leadId, itineraryId)
    } else {
      this._modalPopupService.openReviewDmcQuoteView(itineraryId, leadId, clientId);
    }
  }

  downloadQuoteAsPdf(quoteId: any) {
    this._dmcQuoteService.getQuoteTemplateHtml(quoteId).subscribe((quoteAsHtml) => {
      this._pdfServie.generatePdf(quoteAsHtml, true).subscribe(
        (blob) => {
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = `Quote_${quoteId}.pdf`;
          link.click();
          URL.revokeObjectURL(link.href);
        },
        (error) => {
          console.error('Error generating PDF:', error);
        }
      );
    })
  }

  // Check if quote if fit to convert into quote and then finalize
  async checkAndFinalizeQuote(quoteId: any, leadId: any, clientId: any) {
    this._modalPopupService.openReviewDmcQuoteView(quoteId, leadId, clientId);
  }

  // quote Grid functions end

  // Task grid funtions start
  // Tasks functions
  editTask(editTaskId: any) {
    this._modalPopupService.openTasksForm(editTaskId, null, (goNew) => { });
  }

  async deleteTask(data: any) {
    if (await this._globalService.confirmActionPopup(`Are you sure to delete ${data}`, "Confirm Delete", "Yes")) {
      this._tasksService.deleteTask(data).subscribe((data) => {
        this.getDefaultTasks()
      })
    }

  }

  viewTask(data: any) {
    this._router.navigate([`tasks/details/${data}`]);
  }

  taskStatusChanged(event: any) {
    let taskData = event.row;
    // Get lead data and update
    this._tasksService.getTask(taskData.taskId).subscribe((data) => {
      taskData = data;
      taskData.status = event.statusValue;
      this._tasksService.editTask(taskData.taskId, taskData).subscribe((data) => {
        this._reloadService.triggerTasksReload();
      })
    })

  }
  // Task grid funtions End

  // Lead of client fintions
  //  Open quote view on click from grid
  quoteIdClicked(event: any) {
    let row = event.row;
    if (row.itineraryId && row.leadId) {
      this._dmcQuoteService.getQuoteData(row.itineraryId).subscribe({
        next: (data: any) => {
          this._modalPopupService.openReviewDmcQuoteView(row.itineraryId, row.leadId, row.clientId);
        },
        error: (error: any) => {
          this._responseNotificationService.showMessage("Error fetching quote data.", true)
        }
      })
    }
  }

  addInvoice(){
    this._modalPopupService.openInvoiceForm(null, this.leadIdUrl, null, () => {
      this.getDefaultInvoicesForLead();
    })
  }

  ngOnDestroy() {
    this.subscribeToCallsEvent?.unsubscribe();
  }

  
  openLeadWhatsappNumber(){
    const phone = `${this.leadDetails.phoneNumber.countryCode}${this.leadDetails.phoneNumber.phone}`
    this._globalService.openNumberWhatsappWeb(phone)
  }
  openLeadEmail(){
    const email = this.leadDetails.email;
    if(!email){
      this._responseNotificationService.showMessage("This lead does'nt contain email!", true);
      return;
    }
    this._globalService.openEmailApp(email);
  }

  async callLead() {
    if (!this.leadDetails?.phoneNumber) {
      this._responseNotificationService.showMessage("This lead does'nt contain a phone number!", true);
      return;
    }
    if(await this._globalService.confirmActionPopup(`Are you sure to call to ${this.leadDetails.firstName} ${this.leadDetails.lastName} from mobile?`, "Confirm Call Initialization", "Call Now")) {
      this._callsService.addCallNotification(this.leadDetails.leadId, this.leadDetails.phoneNumber).subscribe({
        next: () => {
          this._responseNotificationService.showMessage("Call Initiated, please check your mobile");
        },
        error: () => {
          this._responseNotificationService.showMessage("Failed to send call notification, please try again.", true);
        }
      });
    }
    
  }

}
